import { render, staticRenderFns } from "./points_task_Invite.vue?vue&type=template&id=f29b7f30&scoped=true"
import script from "./points_task_Invite.vue?vue&type=script&lang=js"
export * from "./points_task_Invite.vue?vue&type=script&lang=js"
import style0 from "./points_task_Invite.vue?vue&type=style&index=0&id=f29b7f30&prod&lang=scss&scoped=true"
import style1 from "./points_task_Invite.vue?vue&type=style&index=1&id=f29b7f30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29b7f30",
  null
  
)

export default component.exports